import { useCallback } from 'react';
import { useInjection } from '../di';
import { getDeviceId } from './getDeviceId';
import { tokens } from './tokens';

export const useDeviceIdProvider = () => {
  const storage = useInjection(tokens.DEVICE_ID_STORAGE);
  const generator = useInjection(tokens.DEVICE_ID_GENERATOR);
  return useCallback(() => getDeviceId(storage, generator), [storage, generator]);
};
